function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_O2C_API_URL || process.env.REACT_APP_ORDER_FULFILLMENT_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }
  return 'https://dev-agent.savictech.com/o2c';
}

const BASE_URL = resolveBaseUrl();

async function apiFetch(path, options = {}) {
  try {
    return await fetch(`${BASE_URL}${path}`, options);
  } catch (_err) {
    throw new Error(
      `Cannot connect to O2C backend at ${BASE_URL}. ` +
      'Set REACT_APP_O2C_API_URL if needed.'
    );
  }
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;

    try {
      const data = await res.json();
      if (Array.isArray(data?.detail)) {
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data?.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}

    throw new Error(detail);
  }

  return res.json();
}

export const ingestPurchaseOrder = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiFetch('/ingest-po/extract', {
    method: 'POST',
    body: formData,
  }).then(handleResponse);
};

export const confirmIngestedPurchaseOrder = (payload) =>
  apiFetch('/ingest-po/confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const getOrders = () =>
  apiFetch('/orders').then(handleResponse);

export const getOrderDetail = (orderId) =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/detail`).then(handleResponse);

export const processOrder = (orderId) =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/process`, {
    method: 'POST',
  }).then(handleResponse);

export const approveOrder = (orderId, decision = 'approve') =>
  apiFetch(`/orders/${encodeURIComponent(orderId)}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ decision }),
  }).then(handleResponse);

export { BASE_URL as O2C_API_BASE_URL };
